<template>
  <!-- START ROOT BRANCH CONTAINER -->
  <v-container fluid pa-0 mt-0 fill-height >
    <v-layout wrap row justify-content-center >
    <!-- START rHeader component -->
    <rHeader
      v-if="branchInfo"
      :title_first_line="branchInfo.branch.show_header == 'Tak' ? $t(branchInfo.branch.header): ''"
      :title_second_line="branchInfo.branch.show_header == 'Tak' ? $t(branchInfo.branch.branch_name) : ''"
      :herb_image="branchInfo.branch.image"
      :header_image="globals.topimage"
    ></rHeader>
    <!-- END rHeader component -->
    <!-- START BRANCH FORM CONTAINER -->
    <v-container id="content" grid-list-md :style="{
      'background-color': (this.$store.state.high_contrast) ? 'black' : 'white',
      'border-radius': '10px',
      'border': (this.$store.state.high_contrast) ? '1px solid yellow' : '1px solid lightgray', 
      }">
      <v-layout wrap row v-if="branchInfo && branchInfo.branch.online">
        <v-flex xl12 md12 sm12 xs12>
            <router-link
            :to="this.$route.path + '/branchqueueinfo'"
            v-if="globals.queueinfo && globals.queueinfo.split(',').includes('Strona oddziału')"
            >
            <v-btn block color="info">{{ $t("branch_queueinfo") }}</v-btn>
            </router-link>
            <router-link to="/cancelall" v-if="globals.cancelallbutton && globals.cancelallbutton.split(',').includes('Strona oddziału')">
              <v-btn block color="secondary">{{ $t("withdrawconsent") }}</v-btn>
            </router-link>
        </v-flex>
        <!-- START BRANCH INFO CONTAINER -->
        <v-flex xl6 md6 sm12 xs12>
          <v-layout wrap>
            <!-- START BRANCH INFO HEADER CONTAINER -->
            <v-flex class="text-center">
              <h3 class="display-2">{{ $t('read_carefully') }}</h3>
            </v-flex>
            <!-- END BRANCH INFO HEADER CONTAINER -->
            <!-- START BRANCH INFO TEXT CONTAINER -->
            <rTextBox v-if="branchInfo">
              <template v-slot:content>
                <v-flex v-html="$t(branchInfo.branch.info)" subheading></v-flex>
              </template>
            </rTextBox>
            <!-- END BRANCH INFO TEXT CONTAINER -->
          </v-layout>
        </v-flex>
        <!-- END BRANCH INFO CONTAINER -->
        <!-- START SERVICES CONTAINER -->
        <v-flex xl6 md6 sm12 xs12>
          <v-layout wrap>
            <!-- START SERVICES HEADER CONTAINER -->
            <v-flex class="text-center">
              <h3 class="display-2">{{ $t('select_service') }}</h3>
            </v-flex>
            <!-- END SERVICES HEADER CONTAINER -->
            <!-- START SERVICES PICKER CONTAINER -->
            <rServicesList
              :services="branchInfo.services"
              :globals="globals"
              v-if="branchInfo"
              @serviceChanged="serviceChanged"
            />
            <!-- END SERVICES PICKER CONTAINER -->
          </v-layout>
        </v-flex>
        <!-- END SERVICES CONTAINER -->
        <!-- START FORM CONTAINER -->
        <v-flex v-if="dates && dates.DATES.length > 0">
          <!-- START FORM -->
          <v-form v-model="form_valid" ref="form" lazy-validation>
            <!-- START FORM LAYOUT-->
            <v-layout column>
              <v-flex>
                <v-layout row>
                  <!-- START FORM rDateLoader COMPONENT -->
                  <rDateLoader
                    id="dateloader"
                    :dates="dates.DATES"
                    :period="dates.PERIOD"
                    :selected="dates.DATES[0]"
                    @dateChanged="dateChanged"
                  ></rDateLoader>
                  <!-- END FORM rDateLoader COMPONENT -->
                  <!-- START FORM rTimeLoader COMPONENT -->
                  <rTimeLoader
                    id="timeloader"
                    :times="times.TIMES"
                    v-if="selected_date && times"
                    @timeChanged="timeChanged"
                  ></rTimeLoader>
                </v-layout>
              </v-flex>
              <!-- END FORM rTimeLoader COMPONENT -->
              <!-- START FORM INPUT FIELDS -->
              <v-flex p-0 m-0 v-if="selected_time">
                <v-flex class="text-center">
                    <h3 class="display-2">{{ $t('fill_form') }}</h3>
                </v-flex>
                <v-flex
                  xs12
                  md12
                  py-0
                  my-0
                  v-for="form_field in branchInfo.form_fields"
                  :key="form_field.id"
                >
                  <v-text-field
                    v-if="['tekst','email'].includes(form_field.type)"
                    v-model="form_values[form_field.sedco_key]"
                    :label="stripHtml($t(form_field.display_name))"
                    :rules="[v => !!v || $t('field_required'),
                      v => new RegExp(form_field.validator).test(v) || $t('input_correct_field') + stripHtml($t(form_field.display_name)).toLowerCase()]"
                    required
                    box
                  ></v-text-field>
                  <v-checkbox 
                    v-if="['checkbox'].includes(form_field.type)"
                    v-model="form_values[form_field.sedco_key]"
                    :label="stripHtml($t(form_field.display_name))"
                    :rules="[v => !!v || $t('field_required')]"
                    ></v-checkbox>
                  <v-layout
                    column
                    wrap
                    p-0
                    m-0
                    v-if="['captcha'].includes(form_field.type) && captcha"
                  >
                    <v-flex p-3 m-0 v-html="captcha.CAPTCHA" captcha text-center></v-flex>
                    <v-flex text-center p-0 m-0 v-if="captcha.READ && speech.hasBrowserSupport()">{{ $t('read_captcha') }}<a class="text-small text-primary" @click="readCaptcha">{{ $t('click_here') }}</a></v-flex>
                    <v-flex text-center>{{ $t('big_letters_only') }}</v-flex>
                    <v-flex p-0 m-0>
                      <v-text-field
                        required
                        box
                        :label="stripHtml($t(form_field.display_name))"
                        :rules="[
                        v => !!v || $t('field_required'), v => captcha.HASH == hash(v) || $t('input_correct_field')
                      ]"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
              <!-- END FORM INPUT FIELDS -->
              <!-- START FORM SUBMIT BUTTON -->
              <v-flex>
                <v-btn
                  block
                  color="secondary"
                  :disabled="!form_valid"
                  @click="submit"
                  v-if="selected_time"
                >{{ $t('take_appointment') }}</v-btn>
              </v-flex>
              <!-- END FORM SUBMIT BUTTON -->
            </v-layout>
            <!-- END FORM LAYOUT-->
          </v-form>
          <!-- END FORM -->
        </v-flex>
        <!-- END FORM CONTAINER -->
      </v-layout>
      <v-layout wrap row justify-content-center>
        <v-flex xl10 md10 sm12 xs12 v-if="branchInfo && !branchInfo.branch.online">
          <h3>{{ $t('no_branch_avaliable') }}</h3>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- END BRANCH FORM CONTAINER -->
    <!-- START rFooter component -->
    <rFooter
      v-if="branchInfo"
      :footer_left="$t(branchInfo.branch.footer_left)"
      :footer_right="$t(branchInfo.branch.footer_right)"
    ></rFooter>
    <!-- END rFooter component -->
    </v-layout>
  </v-container>
  <!-- END ROOT BRANCH CONTAINER -->
</template>

<script>
import RemoteData from "../mixins/remotedata";
import Utilities from "../mixins/utilities";
import Speech from 'speak-tts'
import axios from "axios";
import JQuery from "jquery";
let $ = JQuery;

export default {
  props: {
    globals: null,
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      dates: null,
      times: null,
      selected_service: null,
      selected_service_index: null,
      selected_date: null,
      selected_time: null,
      form_valid: false,
      form_values: {},
      speech: new Speech()
    };
  },
  mixins: [
    Utilities,
    RemoteData({
      branchInfo() {
        return `${env.apiLinks.branchInfo}${this.id}`;
      }
    }),
    RemoteData({
      captcha: env.apiLinks.captcha
    })
  ],
  methods: {
    readCaptcha: function(event){
      this.speech.speak({
        text: this.captcha.READ.split("").join("."),
      });
    },
    serviceChanged: async function(event) {
      this.dates = null;
      this.selected_service = null;
      const promise = this.fetchData(
        "dates",
        `${env.apiLinks.date}${this.id}/${event[0]}`
      );
      this.selected_service = event[0];
      this.selected_service_index = event[1];
    },
    dateChanged: function(event) {
      this.times = null;
      this.selected_date = null;
      this.selected_time = null;
      this.fetchData(
        "times",
        `${env.apiLinks.time}${this.id}/${this.selected_service}/${event}`,
        false
      );
      this.selected_date = event;
    },
    timeChanged: function(event) {
      this.selected_time = event;
    },
    appoitmentFinish: function(response) {
      this.$store.state.loading = false;
      this.$store.state.message = "loading";
      if(response.data.ERROR || response.data.ERROREX){
        this.showErrorMessage("wrong_email_settings", response.data.ERROREX);
      }else{
        switch (response.data.RESPONSE.TakeAppointmentResult.Code) {
          case 0:
            this.appoitmentSuccess(response.data);
            break;
          case -3:
            this.appoitmentFailed(response.data);
            this.selected_time = null;
            this.selected_date = null;
            this.serviceChanged([this.selected_service,this.selected_service_index]);
            break;
          default:
            this.appoitmentFailed(response.data);
            break;
        }
      }
    },
    appoitmentSuccess: function(response) {
      response.RESPONSE.AppointmentTicketInfo.branchName = this.branchInfo.branch.branch_name;
      response.RESPONSE.AppointmentTicketInfo.serviceName = this.branchInfo.services[this.selected_service_index]["name"];
      this.showTicket(
        response.RESPONSE.AppointmentTicketInfo,
        "appointment_success",
        this.branchInfo.branch.ticket_message
      );
    },
    appoitmentFailed: function(response) {
      this.showErrorMessage(
        "" + response.RESPONSE.TakeAppointmentResult.Code,
        response.RESPONSE.TakeAppointmentResult.Description
      );
    },
    submit: function(event) {
      if (this.$refs.form.validate()) {
        const formData = {
          BranchID: this.branchInfo.branch.branch_id,
          ServiceID: this.selected_service,
          AppointmentDay: this.selected_date,
          AppointmentTime: this.selected_time,
          CustomerInfo: {
            AdditionalInfo: this.form_values
          },
          LanguagePrefix: "pl",
          SelectedLanguage: this.$i18n.locale,
          SegmentIdentification: "internet"
        };

        var bodyFormData = new FormData();
        bodyFormData.set("JSONForm", JSON.stringify(formData));
        this.$store.state.message = "taking_appointment_progress";
        this.$store.state.loading = true;
        axios({
          method: "post",
          url: env.serwerURL + env.apiLinks.take_appointment,
          data: bodyFormData,
          config: { headers: { "Content-Type": "multipart/form-data" } }
        }).then(this.appoitmentFinish);
      } else {
        this.showErrorMessage("fill_all");
      }
    },
    hash: function(value) {
      if (value) {
        var hash = 5381;
        for (var i = 0; i < value.length; i++) {
          hash = (hash << 5) + hash + value.charCodeAt(i);
        }
        return hash;
      }
    }
  },
  watch: {
    dates: function(val) {
      if (val && val.DATES.length == 0) {
        this.showErrorMessage("no_dates");
      } else {
        setTimeout(function() {
          const dateloader = document.getElementById("dateloader");
          dateloader.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest"
          });
        }, 1000);
      }
    }
  },
  created: function(){
    this.speech.init({'volume': 1, 'rate': 1, 'splitSentences': true});
    this.speech.speak({
        text: '',
    });
    axios({
          method: "GET",
          url: env.cronURL
        }).then((response) => { console.log(response.data) });
  }
};
</script>

<style scoped>
.captcha {
  font-family: "Courier New", monospace !important;
  font-size: 6px;
  font-weight: bold;
  letter-spacing: -1px;
  line-height: 3px;
}

.v-btn{
  height: auto;
}

.v-btn /deep/ .v-btn__content{
  white-space: pre-line !important;
}

</style>